<template>
  <HKLModal
    ref="modal"
    v-bind="proxyAttrs"
    :closable="true"
    :okBtnAction="okBtnAction"
    :hasCancelBtn="false"
    v-on="$listeners"
    @onOkClick="okOnClick"
  >
    <template slot="title">
      <div
        v-html="modalTitle"
      />
    </template>
    <img
      v-if="status === ACCEPT_STATUS.NO_TENANT_ACCEPT"
      v-region-img-src="'wp-no-tenant.png'"
    >
  </HKLModal>
</template>
<script>
import { computed, ref, unref } from '@vue/composition-api'
import keyMirror from 'keymirror'
import lodash from 'lodash'
import HKLModal, { ModalSize } from '../../../controls/Modal/HKLModal'
import { useStoreGetters } from '@/store'
import i18n from '@/utils/i18n'
import EventBus from '@/utils/eventBus'

export default {
  name: 'MainApplyModal',
  components: {
    HKLModal,
  },
  setup (props, { attrs }) {
    const modal = ref(null)
    const { regionName } = useStoreGetters('regions', 'regionName')
    const { currentTenantProject } = useStoreGetters('tenantProject', 'currentTenantProject')

    const hasMainConnAccept = computed(() => lodash.get(unref(currentTenantProject), 'tncAcceptance.mainContractor'))
    const hasTenantAccept = computed(() => lodash.get(unref(currentTenantProject), 'tncAcceptance.tenantUser'))
    const ACCEPT_STATUS = keyMirror({
      NO_TENANT_ACCEPT: null,
      NO_MAINCON_ACCEPT: null,
    })
    const status = computed(() => {
      if (!unref(hasMainConnAccept)) return ACCEPT_STATUS.NO_MAINCON_ACCEPT
      if (!unref(hasTenantAccept)) return ACCEPT_STATUS.NO_TENANT_ACCEPT
      return ''
    })
    const modalTitle = computed(() => {
      const curStatus = unref(status)
      const prefixString = `termsAndConditions.${unref(regionName)}.workPermit`
      switch (curStatus) {
        case ACCEPT_STATUS.NO_MAINCON_ACCEPT:
          return i18n.t(`${prefixString}.hintForNoMainConAccepted`)
        case ACCEPT_STATUS.NO_TENANT_ACCEPT:
          return i18n.t(`${prefixString}.hintForNoTenantAccepted`)
      }
      return ''
    })

    const okBtnAction = computed(() => {
      const curStatus = unref(status)
      return curStatus === ACCEPT_STATUS.NO_MAINCON_ACCEPT ? 'next' : 'ok'
    })

    const okOnClick = computed(() => {
      const curStatus = unref(status)
      return curStatus === ACCEPT_STATUS.NO_MAINCON_ACCEPT
        ? () => EventBus.emit('wp_open_tnc') : () => {}
    })

    const proxyAttrs = computed(() => {
      return Object.assign({}, attrs, {
        size: ModalSize.SMALL,
        width: unref(status) === ACCEPT_STATUS.NO_TENANT_ACCEPT ? '40%' : undefined,
      })
    })
    const open = () => unref(modal).open()

    return {
      modal,
      open,
      regionName,
      proxyAttrs,
      status,
      modalTitle,
      okBtnAction,
      okOnClick,
      ACCEPT_STATUS,
    }
  },
}
</script>
<style lang="scss" scoped>
.content {
  color: #0C3A58;
  font-weight: bold;
}
</style>
